import { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { Icon, IconName } from "./Icon";

type Item = { to: string; label: string; icon: IconName; end?: boolean };

const items: Item[] = [
  { to: "/", label: "Home", icon: "home", end: true },
  { to: "/stock-in", label: "Stock In", icon: "in" },
  { to: "/stock-out", label: "Stock Out", icon: "out" },
  { to: "/transfer-in", label: "Transfer", icon: "truck" },
  { to: "/inventario", label: "Inventario", icon: "chart" },
];

export const BottomNav = forwardRef<HTMLElement>((_props, ref) => {
  return (
    <nav className="tcg-nav" ref={ref}>
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.end}
          className={({ isActive }) => clsx("tcg-nav-item", isActive && "active")}
        >
          {({ isActive }) => (
            <>
              <Icon name={it.icon} size={20} {...(isActive ? {} : {})} />
              <span className="tcg-nav-label">{it.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
});
